import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OptimizerSessionTokenState {
  OptimizerSessionToken: null | number;
}

const initialState: OptimizerSessionTokenState = {
  OptimizerSessionToken: null,
};

const OptimizerSessionTokenSlice = createSlice({
  name: "OptimizerSessionToken",
  initialState,
  reducers: {
    setOptimizerHPPCSessionToken: (state, action: PayloadAction<number>) => {
      state.OptimizerSessionToken = action.payload;
    },
    clearOptimizerSessionToken: (state) => {
      state.OptimizerSessionToken = null;
    },
  },
});

export const { setOptimizerHPPCSessionToken, clearOptimizerSessionToken } = OptimizerSessionTokenSlice.actions;
export default OptimizerSessionTokenSlice.reducer;
